import {
  Component,
  OnInit,
  OnDestroy,
  ContentChild,
  TemplateRef,
} from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { NotificationService } from '@app-services/notification/notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {
  public fullwidth = false;
  public sideContentVisible = true;
  public scrollEnabled = true;
  @ContentChild('sideContent', { static: false }) sideContent: TemplateRef<any>;
  @ContentChild('mainContent', { static: false }) mainContent: TemplateRef<any>;

  //  notifications
  public isOpen = false;
  private isOpenSubscription: Subscription;

  constructor(
    private notificationService: NotificationService,
    public mediaObserver: MediaObserver
  ) {}

  ngOnInit() {
    this.isOpenSubscription = this.notificationService.openStatus.subscribe(
      (isOpen) => {
        this.isOpen = isOpen;
        //this.wasInside = true;
      }
    );
  }

  public hideSideContent(): void {
    this.sideContentVisible = false;
  }

  /**
   * Disables the scrolling provided by the main-layout if the desktop
   * layout is active
   */
  public disableScrollingIfDesktop(): void {
    if (!this.mediaObserver.isActive('xs')) {
      this.scrollEnabled = false;
    }
  }

  /**
   * Enables the scrolling provided by the main-layout
   */
  public enableScrolling(): void {
    this.scrollEnabled = true;
  }

  toggle() {
    this.notificationService.toggle();
  }

  ngOnDestroy() {
    this.isOpenSubscription.unsubscribe();
  }
}
